import { render, staticRenderFns } from "./StatusGroup.vue?vue&type=template&id=e00074d2&scoped=true"
import script from "./StatusGroup.vue?vue&type=script&lang=js"
export * from "./StatusGroup.vue?vue&type=script&lang=js"
import style0 from "./StatusGroup.vue?vue&type=style&index=0&id=e00074d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00074d2",
  null
  
)

export default component.exports